export default __webpack_public_path__ + "static/banner-stores-mobile-84e960d019406c435823efc1cb468c2d.webp";